(function () {
  var ready = function (fn) {
    if (document.readyState !== "loading") {
      fn();
      return;
    }
    document.addEventListener("DOMContentLoaded", fn);
  };

  var buildIframe = function (provider, id, title) {
    var iframe = document.createElement("iframe");
    var src = "";
    if (provider === "youtube") {
      src = "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0";
    } else if (provider === "vimeo") {
      src = "https://player.vimeo.com/video/" + id + "?autoplay=1&title=0&byline=0";
    }
    iframe.src = src;
    iframe.loading = "lazy";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframe.allowFullscreen = true;
    iframe.title = title || "Video";
    return iframe;
  };

  var activate = function (wrapper) {
    if (!wrapper || wrapper.getAttribute("data-active") === "true") return;
    var provider = wrapper.getAttribute("data-video-provider");
    var id = wrapper.getAttribute("data-video-id");
    var title = wrapper.getAttribute("data-video-title");
    if (!provider || !id) return;

    wrapper.innerHTML = "";
    wrapper.appendChild(buildIframe(provider, id, title));
    wrapper.setAttribute("data-active", "true");
  };

  ready(function () {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-lite-video]");
      if (!button) return;
      var wrapper = button.closest(".lite-video");
      activate(wrapper);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      var target = event.target;
      if (!target.matches("[data-lite-video]")) return;
      event.preventDefault();
      var wrapper = target.closest(".lite-video");
      activate(wrapper);
    });
  });
})();
